module.exports = __webpack_public_path__ + "img/play-video-icon2.9b15b344.png";